// extracted by mini-css-extract-plugin
export default {"streamingCursor":"streaming-cursor-module__streamingCursor--BxoTw","blink":"streaming-cursor-module__blink--pGmdK"};